const BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

let authCallbacks = {
  getRefreshToken: () => null,
  onRefreshSuccess: () => {},
  onRefreshFailure: () => {},
};

let refreshPromise = null;

export function setAuthCallbacks(callbacks) {
  authCallbacks = { ...authCallbacks, ...callbacks };
}

async function request(path, options = {}) {
  const url = `${BASE_URL}${path}`;
  const config = {
    credentials: 'include',
    ...options,
    headers: {
      ...options.headers,
    },
  };

  if (options.body && typeof options.body === 'object' && !(options.body instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(options.body);
  }

  let response = await fetch(url, config);

  if (response.status === 401 && !path.includes('/auth/refresh')) {
    response = await handleUnauthorized(path, config);
  }

  if (!response.ok) {
    const error = new Error(`API error: ${response.status}`);
    try {
      error.data = await response.json();
    } catch {
      error.data = { detail: response.statusText };
    }
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) return null;
  return response.json();
}

async function handleUnauthorized(originalPath, originalConfig) {
  if (refreshPromise) {
    await refreshPromise;
    return fetch(`${BASE_URL}${originalPath}`, originalConfig);
  }

  const refreshToken = authCallbacks.getRefreshToken();
  if (!refreshToken) {
    authCallbacks.onRefreshFailure();
    throw new Error('No refresh token available');
  }

  refreshPromise = fetch(`${BASE_URL}/api/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh_token: refreshToken }),
  })
    .then(async (res) => {
      if (!res.ok) {
        authCallbacks.onRefreshFailure();
        throw new Error('Token refresh failed');
      }
      const data = await res.json();
      authCallbacks.onRefreshSuccess(data);
      return data;
    })
    .finally(() => {
      refreshPromise = null;
    });

  await refreshPromise;
  return fetch(`${BASE_URL}${originalPath}`, originalConfig);
}

export function apiGet(path) {
  return request(path);
}

export function apiPost(path, body) {
  return request(path, { method: 'POST', body });
}

export function apiPatch(path, body) {
  return request(path, { method: 'PATCH', body });
}

export function apiDelete(path) {
  return request(path, { method: 'DELETE' });
}
